import { ArrowUpRight, Check } from "lucide-react";
import { CONTACT } from "@/constants/testIds";

export default function ContactSubmitRow({ status, errorMsg }) {
  return (
    <div className="pt-6 flex flex-col sm:flex-row sm:items-center gap-6">
      <button
        type="submit"
        data-testid={CONTACT.submit}
        disabled={status === "loading"}
        className="inline-flex items-center gap-3 bg-ink text-ivory px-10 py-5 text-[11px] tracking-widest2 uppercase font-semibold hover:bg-indigo_deep transition-colors disabled:opacity-60"
      >
        {status === "loading" ? "Sending…" : "Send Inquiry"}
        <ArrowUpRight size={16} />
      </button>

      {status === "success" && (
        <div
          data-testid={CONTACT.success}
          className="inline-flex items-center gap-3 text-monsoon font-light"
        >
          <Check size={18} />
          Thank you — your message is with our curators.
        </div>
      )}
      {status === "error" && (
        <div data-testid={CONTACT.error} className="text-terracotta font-light">
          {errorMsg}
        </div>
      )}
    </div>
  );
}
